module.exports = __webpack_public_path__ + "img/search.1aa64b3f.png";